import { disableScrollLock } from '@/utils/scroll'
import { userCheck } from '@/utils/auth'
import { propagateToCollabs } from '@/router/helpers/collab'

export function beforeEach (to, from, next) {
  disableScrollLock()
  userCheck(next, to.name, from.name, to.meta)
}

export function afterEach (to) {
  propagateToCollabs(to)
}
